import { MathUtils } from "@mp-commons/lib/utils/MathUtils.js";
import { VideoInfoRawData } from "@mp-commons/model/video/VideoInfo.js";

export function populateAuthorPlaceholder(refVideo: VideoInfoRawData, placeholder: string, window: Window) {
    if(refVideo && placeholder && refVideo.meta?.channelName && refVideo.meta?.channelUrl) {
        const elems = window.document.getElementsByClassName(placeholder);
        const authorName = refVideo.meta?.channelName;
        const authorUrl = refVideo.meta?.channelUrl;
        const authorEl = window.document.createElement('a');
        authorEl.href = authorUrl;
        authorEl.innerText = authorName;

        for (let index = 0; index < elems.length; index++) {
            elems.item(index).innerHTML = authorEl.outerHTML;
        }
    }
}

export function populateViewsPlaceholder(refVideo: VideoInfoRawData, placeholder: string, window: Window) {
    if(refVideo && placeholder && refVideo.socialInfo?.view) {
        const elems = window.document.getElementsByClassName(placeholder);
        const viewsCount = refVideo.socialInfo.view;

        for (let index = 0; index < elems.length; index++) {
            elems.item(index).innerHTML = MathUtils.addThousandSepartor(viewsCount, "."); 
        }
       
    }

   
}